import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-my-account',
  templateUrl: './footer-my-account.component.html',
  styleUrls: ['./footer-my-account.component.scss']
})
export class FooterMyAccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
